import GeneratorService from "@/services/GeneratorService";

export const generator = {
  namespaced: true,
  state: {
    generator: {},
  },
  actions: {
    getGenerator({ commit }, payload) {
      return GeneratorService.GetGenerator(payload).then(
        (generator) => {
          return Promise.resolve(generator);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postGenerator({ commit }, payload) {
      return GeneratorService.PostGenerator(payload).then(
        (generator) => {
          return Promise.resolve(generator);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putGenerator({ commit }, payload) {
      return GeneratorService.PutGenerator(payload).then(
        (generator) => {
          return Promise.resolve(generator);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteGenerator({ commit }, payload) {
      return GeneratorService.DeleteGenerator(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getGeneratorOData({ commit }, payload) {
      return GeneratorService.GetGeneratorOData(payload).then(
        (generator) => {
          return Promise.resolve(generator);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    updateGeneratorTabela({ commit }, payload) {
      return GeneratorService.UpdateGeneratorTabela(payload).then(
        (generator) => {
          return Promise.resolve(generator);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default generator;
